import React from 'react';
import useTheme from '../../hooks/useTheme';

const ThemeToggle = () => {
  const { isDark, toggle } = useTheme();

  return (
    <button
      onClick={toggle}
      className="relative w-9 h-9 rounded-lg border flex items-center justify-center text-sm transition-all"
      style={{
        background: 'var(--color-bgSurfaceLight)',
        borderColor: 'var(--color-borderStrong)',
        color: 'var(--color-textSecondary)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-orange)';
        e.currentTarget.style.color = 'var(--color-orange)';
        e.currentTarget.style.background = 'var(--color-orangeBg)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'var(--color-borderStrong)';
        e.currentTarget.style.color = 'var(--color-textSecondary)';
        e.currentTarget.style.background = 'var(--color-bgSurfaceLight)';
      }}
      title={`Switch to ${isDark ? 'Light' : 'Dark'} Mode`}
    >
      <i className={`fas ${isDark ? 'fa-sun' : 'fa-moon'} text-[11px]`} />
    </button>
  );
};

export default ThemeToggle;